import Layout from '@/views/layout'

export default [{
    path: '/Aybusinessinquiry',
    component: Layout,
    redirect: '/firstpurchaseorder/index',
    meta: {
        title: 'function.menu.businessManager'//业务管理
    },
    children: [
        {
            path: 'in-register/index',
            component: () => import('@/views/in-register/index'),
            name: 'InRegister',
            meta: { title: 'poOrder.type.new.member' }  // 经销商注册
        },
        {
            //首购订单 (代办处)
            path: 'firstpurchaseorderAgent/index',
            component: () => import('@/views/ay-business-inquiry/firstpurchaseorderAgent/index'),
            name: 'FirstpurchaseOrderAgent',
            meta: { title: 'poOrder.type.first.order' }
        },
        {
            //首购订单(经销商)
            path: 'firstpurchaseorder/index',
            component: () => import('@/views/ay-business-inquiry/firstpurchaseorder/index'),
            name: 'FirstpurchaseOrder',
            meta: { title: 'poOrder.type.first.order' }
        },
        {
            //升级订单
            path: 'upgradeorder/index',
            component: () => import('@/views/ay-business-inquiry/upgradeorder/index'),
            name: 'UpgradeOrder',
            meta: { title: 'poOrder.type.upgrade.order' }
        },
        {
            //重消订单
            path: 'cancelorderagain/index',
            component: () => import('@/views/ay-business-inquiry/cancelorderagain/index'),
            name: 'CancelorderAgain',
            meta: { title: 'poOrder.type.repeat.order' }
        },
        {
            //F000换货
            path: 'exchangegoods/index',
            component: () => import('@/views/ay-business-inquiry/exchangegoods/index'),
            name: 'ExchangeGoods',
            meta: { title: 'busi.pickup' }
        },
        {
            //订单查询
            path: 'orderquery/index',
            component: () => import('@/views/ay-business-inquiry/orderquery/index'),
            name: 'OrderQuery',
            meta: { title: 'poOrder.orderQuery.title' }
        },
        {
            //订单查看
            path: 'orderquery/view',
            component: () => import('@/views/ay-business-inquiry/orderquery/view'),
            name: 'ViewOrderquery',
            meta: { title: 'paypal.viewOrder' },
            hidden: true
        },
        {
            //订单 其他
            path: 'orderquery/orderqueryothers',
            component: () => import('@/views/ay-business-inquiry/orderquery/orderqueryothers'),
            name: 'OrderQueryOthers',
            meta: { title: 'Modify consignee & buyer information' },
            hidden: true
        },
        {
            //积分换货
            path: 'integralexchange/index',
            component: () => import('@/views/ay-business-inquiry/integralexchange/index'),
            name: 'IntegralExchange',
            meta: { title: 'poorder.pv.goods' }
        },
        {
            //补货单
            path: 'replenishmentorder/index',
            component: () => import('@/views/ay-business-inquiry/replenishmentorder/index'),
            name: 'ReplenishmentOrder',
            meta: { title: 'miagent.service.point.buhuo' }
        },
        {
            //周转补货单列表
            path: 'turnoverOrderList/index',
            component: () => import('@/views/ay-business-inquiry/turnoverOrderList/index'),
            name: 'TurnoverOrderList',
            meta: { title: 'poOrderAgentList.title' }
        },
        {
            //周转补货单明细
            path: 'turnoverOrderList/view',
            component: () => import('@/views/ay-business-inquiry/turnoverOrderList/view'),
            name: 'TurnoverOrderView',
            meta: { title: 'sys.to.view.detailse' },
            hidden: true
        },
        {
            //资格码报单
            path: 'qualification/index',
            component: () => import('@/views/ay-business-inquiry/qualification/index.vue'),
            name: 'Qualification',
            meta: { title: 'QualificationCodeOrder' }
        },
        {
            //资格码报单2
            path: 'qualificationafrica/index',
            component: () => import('@/views/ay-business-inquiry/qualificationafrica/index.vue'),
            name: 'Qualificationafrica',
            meta: { title: 'QualificationafricaCodeOrder' }
        }
    ]
}]
